// src/theme/palette.js

export const lightPalette = {
  mode: 'light',
  primary: {
    main: '#1E3A8A', // Deep Slate Blue
    light: '#3B82F6',
    dark: '#172554',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#D97706', // Warm Gold/Amber
    light: '#F59E0B',
    dark: '#B45309',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#059669', // Emerald Green
    light: '#34D399',
    dark: '#064E3B',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#F59E0B', // Amber
    light: '#FBBF24',
    dark: '#78350F',
    contrastText: '#0F172A',
  },
  error: {
    main: '#DC2626', // Crimson Red
    light: '#F87171',
    dark: '#7F1D1D',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#2563EB',
    light: '#60A5FA',
    dark: '#1E40AF',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#F8FAFC', // Slate 50
    paper: '#FFFFFF', // Solid White
  },
  text: {
    primary: '#0F172A', // Slate 900
    secondary: '#475569', // Slate 600
    disabled: '#94A3B8',
  },
  divider: '#E2E8F0', // Slate 200
  action: {
    hover: '#F1F5F9', // Slate 100
    selected: '#E2E8F0',
    disabledBackground: '#E2E8F0',
    disabled: '#94A3B8',
  },
};

export const darkPalette = {
  mode: 'dark',
  primary: {
    main: '#60A5FA', // Electric Blue
    light: '#93C5FD',
    dark: '#1E3A8A',
    contrastText: '#0B0F19',
  },
  secondary: {
    main: '#FBBF24', // Soft Gold
    light: '#FDE047',
    dark: '#D97706',
    contrastText: '#0B0F19',
  },
  success: {
    main: '#34D399', // Soft Emerald
    light: '#6EE7B7',
    dark: '#064E3B',
    contrastText: '#0B0F19',
  },
  warning: {
    main: '#FBBF24', // Soft Amber
    light: '#FDE047',
    dark: '#78350F',
    contrastText: '#0B0F19',
  },
  error: {
    main: '#F87171', // Soft Crimson
    light: '#FCA5A5',
    dark: '#7F1D1D',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#60A5FA',
    light: '#93C5FD',
    dark: '#1E40AF',
    contrastText: '#0B0F19',
  },
  background: {
    default: '#0B0F19', // Obsidian Blue
    paper: '#111827', // Slate 900
  },
  text: {
    primary: '#F9FAFB', // Slate 50
    secondary: '#9CA3AF', // Slate 400
    disabled: '#4B5563',
  },
  divider: '#1F2937', // Slate 800
  action: {
    hover: '#1F2937', // Slate 800
    selected: '#374151',
    disabledBackground: '#1F2937',
    disabled: '#4B5563',
  },
};
